import React from "react";
import ReactDOM from "react-dom";

import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Lorem,
  ModalFooter,
  SimpleGrid,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  useColorModeValue,
  Text,
  Container,
  Box,
  Flex,
  Image,
} from "@chakra-ui/react";
import { Formik, Form, Field } from "formik";
import Select from "react-select";
import Yup from "yup";
import Card from "components/Card/Card";

function LoadingModal(props) {
  const { isOpen, onClose, data, type, problem } = props;

  return (
    <>
      {isOpen && (
        <Container mt="15">
          <Card>
            <Flex direction="column" textAlign="center">
              <Text fontSize="xl" fontWeight="bold">
                SWD jest aktualnie niedostępne.
              </Text>
              {problem ? (
                <>
                  <Text fontSize="md">
                    Napotkano błąd podczas łączenia z serwerem, spróbuj ponownie
                    później.
                  </Text>
                  <Text fontSize="md">
                    Jeżeli problem nie ustępuje zgłoś to na discordzie.
                  </Text>
                  <Image src={"https://i.imgur.com/BBHpoQS.gif"} mt="15" />
                </>
              ) : (
                <>
                  <Text fontSize="md">
                    Trwa aktualnie przerwa techniczna.
                  </Text>
                  <Text fontSize={"md"}>
                    Sprawdź ponownie za chwilę.
                  </Text>
                  <Image src={"https://i.imgur.com/Df2x3jz.gif"} mt="15" />
                </>
              )}
            </Flex>
          </Card>
        </Container>
      )}
    </>
  );
}

export default LoadingModal;
